import styled from 'styled-components';

const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: inherit;

  &:disabled {
    cursor: not-allowed;
    svg {
      stroke: var(--color-dim-gray);
    }
  }

  &:not(:disabled):hover {
    svg {
      stroke: var(--color-light-gray);
    }
  }

  svg {
    stroke: var(--color-deep-gray);
  }
`;

export default IconButton;
